var MegaMenu = {
    Init:function(){
		$('#nav li.megamenu').each(function (index) {
			var currentListItem = $(this);
			var dropDownAttr = currentListItem.attr('data-dropdown');
			if(dropDownAttr != null){
				var menuToShow = $('#'+dropDownAttr);
				menuToShow.css({'display':'none'});
				menuToShow.css({'padding-top':currentListItem.offset().top + 30 +'px'});

				currentListItem.hover(function(){
					MegaMenu.CurrentListItem = currentListItem;
					MegaMenu.CurrentMenu = menuToShow;
					MegaMenu.MenuIsHovered = true;
					if(MegaMenu.PreviousMenu && MegaMenu.PreviousMenu != MegaMenu.CurrentMenu){
						MegaMenu.AnimateMenus();
					}else{
						MegaMenu.Show();
					}
				},function(){
					MegaMenu.MenuIsHovered = false;
					MegaMenu.SetCloseDelay();
				});
				
				var plank = $('#plank', menuToShow);
				plank.hover(function(){
					MegaMenu.MenuIsHovered = true;
				},function(){
					MegaMenu.MenuIsHovered = false;
					MegaMenu.SetCloseDelay();
				});
				
				$('#deck li', plank).hover(function(){
					var imageToShow = $('a',this).attr('data-img');
					$('#drink img#'+imageToShow).css('display','block');
				},function(){
					var imageToShow = $('a',this).attr('data-img');
					$('#drink img#'+imageToShow).css('display','none');
				});
			}
		});
	},
	AnimateMenus:function(){
    MegaMenu.PreviousMenu.parents('#nav li.megamenu').removeClass(MegaMenu.OnHoverClassName);
    MegaMenu.PreviousMenu.css('display','none');
    MegaMenu.PreviousMenu = MegaMenu.CurrentMenu;
    MegaMenu.CurrentListItem.addClass(MegaMenu.OnHoverClassName);
    MegaMenu.CurrentMenu.css('display','block');
	},
	Show:function(){
		MegaMenu.CurrentListItem.addClass(MegaMenu.OnHoverClassName);
		MegaMenu.CurrentMenu.css('display','block');
		MegaMenu.PreviousMenu = MegaMenu.CurrentMenu;
	},
	SetCloseDelay:function(){
		clearTimeout(MegaMenu.Timer);
		MegaMenu.Timer = setTimeout(
		  function () {
		    if(!MegaMenu.MenuIsHovered){
				MegaMenu.Close();
			}
		 },250);
	},
	Close:function(){
		if(MegaMenu.CurrentListItem != null && MegaMenu.CurrentMenu != null){
			MegaMenu.CurrentListItem.removeClass(MegaMenu.OnHoverClassName);
			MegaMenu.CurrentMenu.css('display','none');
			MegaMenu.PreviousMenu = null;
		}
	},
	CurrentListItem:null,
	CurrentMegaMenu:null,
	MenuIsHovered:false,
	Timer:null,
	PreviousMenu:null,
	OnHoverClassName:'list-on'
};

$(document).ready(function () {
  MegaMenu.Init();
});